(function () {
  var drawer = document.querySelector('.xx-drawer');
  var buttons = document.querySelectorAll('[data-mobile-nav-open]');
  if (!drawer || !buttons.length) return;

  function setOpen(open) {
    drawer.hidden = !open;
    document.body.style.overflow = open ? 'hidden' : '';
    buttons.forEach(function (b) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
  }

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () { setOpen(drawer.hidden); });
  });

  drawer.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function () { setOpen(false); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setOpen(false);
  });
})();